<template>
<div class="chapter">
<div class="inner_page">
<a id="pvi"></a><a id="pvii"></a>
<blockquote class="sink">
<p class="center ">Glory Days, well, they’ll pass you by.</p>
<p class="center ">—<span class="smallcaps">BRUCE SPRINGSTEEN,</span><br/> from <em>Born in the U.S.A.,</em> released June 4, 1984</p>
</blockquote>
<div class="timebreak "> <hr class="context "/></div>
<blockquote class="spaceabove1">
<p class="center "><span class="smallcaps">REPORTER:</span> “Is it true you can fly?”</p>
<p class="center "><span class="smallcaps">MICHAEL JORDAN:</span> “No. Well, maybe for a little.”</p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front03.vue?56e6031a